import { Box, Flex, FlexProps } from '@chakra-ui/react';
import { pxToRem } from '@cyberkongz/ui';

export type BadgeColor = 'primary' | 'secondary' | 'tertiary' | 'text';

export type BadgeProps = {
  badgeColor?: BadgeColor;
  withDot?: boolean;
} & FlexProps;

export function Badge({ badgeColor = 'text', children, withDot, onClick, ...rest }: BadgeProps) {
  return (
    <Flex
      textStyle="p-sm"
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
      alignItems="center"
      border="thin"
      borderColor={badgeColor}
      pt={1}
      pb={1}
      px={3}
      borderRadius="3em"
      display="inline-flex"
      color={badgeColor}
      {...rest}
    >
      {withDot ? (
        <Box boxSize={pxToRem(6)} bg={badgeColor} borderRadius="50%" mr={pxToRem(6)} />
      ) : null}
      <Box>{children}</Box>
    </Flex>
  );
}
